// extracted by mini-css-extract-plugin
var _1 = "igx6vGAAokHem3sE1Kq9";
var _2 = "dkmNYwNSlRaPQxa8UZZn";
var _3 = "igi7VlSMCszw4WCtkNlu";
var _4 = "XUyUB9ZKwFujtJjdAZ4P";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "p0GTrMb61YCbhqIhFadA";
var _13 = "pRz_6Ew6LHwN7dzzWncL";
var _14 = "1200px";
var _15 = "992px";
var _16 = "1366px";
var _17 = "768px";
var _18 = "1475px";
var _19 = "576px";
var _1a = "1600px";
var _1b = "320px";
var _1c = "2500px";
var _1d = "bz2loD_aoL4dYpl7e16A";
var _1e = "wgnT0swGXpIfMLC161Pa";
var _1f = "oyFkLXMWGfj7lnnMeq_b";
var _20 = "Vo2hgqwiaErSuHW9Yx6p";
export { _1 as "base-link", _2 as "clone", _3 as "collapse", _4 as "collapsed", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "hidden", _13 as "reset-button", _14 as "screenlg", _15 as "screenmd", _16 as "screenml", _17 as "screensm", _18 as "screenxlg", _19 as "screenxs", _1a as "screenxxlg", _1b as "screenxxs", _1c as "screenxxxlg", _1d as "selected", _1e as "single-page-responsive-font-size", _1f as "treeItem", _20 as "wrapper" }
export default { "base-link": _1, "clone": _2, "collapse": _3, "collapsed": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "hidden": _12, "reset-button": _13, "screenlg": _14, "screenmd": _15, "screenml": _16, "screensm": _17, "screenxlg": _18, "screenxs": _19, "screenxxlg": _1a, "screenxxs": _1b, "screenxxxlg": _1c, "selected": _1d, "single-page-responsive-font-size": _1e, "treeItem": _1f, "wrapper": _20 }
